import { Link, Text } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

export const ReportSampleLink = ({ link }: { link?: string | null }) => {
  if (link) {
    return (
      <Link
        color="brightGreen.600"
        fontSize="xs"
        fontWeight="800"
        variant="link"
        as={NavLink}
        to={link || ''}
        whiteSpace="nowrap"
        mr={2}
      >
        View Sample
      </Link>
    );
  } else {
    return (
      <Text color="gray.400" fontWeight="600" fontSize="xs">
        sample report not available yet
      </Text>
    );
  }
};
